import { render, staticRenderFns } from "./VProducts.vue?vue&type=template&id=89c9bed8"
import script from "./VProducts.vue?vue&type=script&lang=js"
export * from "./VProducts.vue?vue&type=script&lang=js"
import style0 from "./VProducts.vue?vue&type=style&index=0&id=89c9bed8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports